module.exports = __webpack_public_path__ + "img/classify-item2-active.bf8b4b24.png";